import { createContext, useContext, useMemo } from 'react';
import { mergeDetailsRenderHeaderConfig, mergeDetailsRenderPanelConfig } from '../utils/detailsRenderConfigUtils';
import { useContentDetailsDataProvider } from './ContentDetailsDataProvider';
import { useAuthInfoProvider } from 'content-management-data-lib';
import useAssociatedForms from '../hooks/useAssociatedForms';
import { jsx as _jsx } from "react/jsx-runtime";
export const DetailsRenderConfigContext = /*#__PURE__*/createContext(undefined);
const DetailsRenderConfigProvider = ({
  children,
  detailsPanelConfigOverrides = {},
  detailsHeaderConfigOverrides = {},
  titleConfigOverride = {}
}) => {
  const {
    contentObject,
    contentId
  } = useContentDetailsDataProvider();
  const {
    getIsUngatedToUseResolvedStateProperty
  } = useAuthInfoProvider();
  const isUngatedToUseResolvedStateProperty = getIsUngatedToUseResolvedStateProperty();
  const {
    forms
  } = useAssociatedForms(contentId);
  const value = useMemo(() => {
    const conditionalRowData = {
      forms
    };
    return {
      detailsPanelConfig: mergeDetailsRenderPanelConfig(detailsPanelConfigOverrides, contentObject, isUngatedToUseResolvedStateProperty, conditionalRowData),
      detailsHeaderConfig: mergeDetailsRenderHeaderConfig(detailsHeaderConfigOverrides, contentObject, isUngatedToUseResolvedStateProperty),
      titleConfigOverride
    };
  }, [detailsPanelConfigOverrides, contentObject, isUngatedToUseResolvedStateProperty, detailsHeaderConfigOverrides, forms, titleConfigOverride]);
  return /*#__PURE__*/_jsx(DetailsRenderConfigContext.Provider, {
    value: value,
    children: children
  });
};
export default DetailsRenderConfigProvider;
export function useDetailsRenderConfig() {
  const context = useContext(DetailsRenderConfigContext);
  if (context === undefined) {
    throw new Error('useDetailsRenderConfig must be used within a DetailsRenderConfigProvider');
  }
  return context;
}